import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsPlanEntryTaxiDriverDraft from "./billings-plan-entry-taxi-driver-draft";
import BillingsPlanEntryTaxiDriverDraftParams from "./billings-plan-entry-taxi-driver-draft-params";

const usePlanEntryTaxiDriverBillingDraft = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsPlanEntryTaxiDriverDraft | null>(null);

  const load = async (
    params: BillingsPlanEntryTaxiDriverDraftParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiDriverBillingData =
        await billingService.getPlanEntryTaxiDriverBillingsDraft(
          params,
          signal,
        );

      setData(taxiDriverBillingData);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default usePlanEntryTaxiDriverBillingDraft;
